module.exports = __webpack_public_path__ + "img/logo_square_slurp.f764aafb.png";